import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import {
  StyledDialogTitleTypography
} from '../shared-styles/dialog-title-styles';


export const DialogContentOptions = () => {
  const { t } = useTranslation();
  return (
    <Typography
      component="span"
      sx={{
        display: 'block',
        color: 'var(--kyocera-dark-grey)',
        fontSize: "14px",
      }}
    >
      <Trans i18nKey="leave_confirm_prompt_msg_1" />
      <br />
      <Trans i18nKey="leave_confirm_prompt_msg_2" />
    </Typography>
  );
};

export const DialogTitleOptions = () => {
  const { t } = useTranslation();
  return (
    <>
      <StyledDialogTitleTypography as="span">{t('leave_confirm_prompt_title')}</StyledDialogTitleTypography>
    </>
  );
};

type IConfirmProps = {
  onConfirm?: () => void;
}

export const ConfirmationTextOptions = (props: IConfirmProps) => {
  const { t } = useTranslation();
  return (
    <>
      {t('common_leave')}
    </>
  );
};

type ICancelProps = {
  onCancell?: () => void;
}

export const CancellTextOptions = (props: ICancelProps) => {
  const { t } = useTranslation();
  return (
    <>
      {t('common_cancel')}
    </>
  );
};

const sharedButtonSx = {
  minWidth: '100px !important',
  padding: '6px 16px !important',
  borderRadius: '4px !important',
  textTransform: 'none',
};

export const dialogOptions = {
  title: <DialogTitleOptions />,
  description: <DialogContentOptions />,
  confirmationText: <ConfirmationTextOptions />,
  cancellationText: <CancellTextOptions />,
    dialogProps: {
    maxWidth: 'sm' as const,
    fullWidth: true,
    disableEscapeKeyDown: true,
  },
  contentProps: {
    sx: {
      fontSize: '120px', 
      color: "var(--kyocera-dark-grey)", 
      lineHeight: 1.5,
      p: 4, mt: '32px'
    },
  },
  allowClose: false,
  titleProps: {
    sx: {
      pt: 4,
      pl: 4,
      pr: 4,
      pb: 0,
      display: 'flex',
    },
  },
  confirmationButtonProps: {
    variant: 'contained',
    sx: { ...sharedButtonSx, bgcolor: 'primary.main', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.main' } },
  },
  cancellationButtonProps: {
    variant: 'contained',
    sx: { ...sharedButtonSx, bgcolor: 'primary.darker', color: 'primary.light', '&:hover': { bgcolor: 'primary.darker' } },
  },
  dialogActionsProps: {
    sx: { p: 2, gap: 1.5 }, 
  },
};

